import { Id, useAppNotification } from '@feature/utils';

import { MinStdIndicatorItemForm } from './form/MinStdIndicatorItemForm';
import { useMinStdEditIndicatorItem } from './model/MinStdQuery';
import { IndicatorItem, IndicatorItemRequest, MinStdIndicatorType } from './model/MinStdTypes';

interface MinStdIndicatorItemEditProps {
  close: () => void;

  authorId: Id;
  indicatorCode: string;
  year: number | null;

  editItem: IndicatorItem;
  indicatorType: MinStdIndicatorType;

  legend: string | null;

  alreadySelectedIds: number[];
  showPointsField: boolean;
}

export function MinStdIndicatorItemEdit(props: MinStdIndicatorItemEditProps) {
  const { close, authorId, indicatorCode, editItem, indicatorType, legend, alreadySelectedIds, year, showPointsField } =
    props;
  const { mutate, isPending } = useMinStdEditIndicatorItem(authorId, indicatorCode, editItem.id);
  const notification = useAppNotification();
  const onSubmit = (values: IndicatorItemRequest) => {
    mutate(
      {
        ...values,
        indicatorType,
      },
      {
        onSuccess: () => {
          notification.success();
          close();
        },
        onError: notification.error,
      },
    );
  };
  return (
    <MinStdIndicatorItemForm
      onCancel={close}
      onSubmit={onSubmit}
      isSubmitting={isPending}
      defaultValues={{
        ...editItem,
        year,
      }}
      indicatorType={indicatorType}
      legend={legend}
      authorId={authorId}
      indicatorCode={indicatorCode}
      alreadySelectedIds={alreadySelectedIds}
      year={year}
      showPointsField={showPointsField}
    />
  );
}
